import React, { FunctionComponent } from 'react';
import MATERIAL_TYPES from '../../../__core/Enums/MaterialTypes';
import { IMaterialForMenu } from '../Interfaces/IMaterialForMenu';
import { defaultTheme } from '../../../__core/Themes/Default';
import PASS_STATUS from '../../../__core/Enums/PassStatus';
import { SearchMaterial } from '../../Course/Types/SearchResult';

type MaterialIconProviderProps = {
  material: IMaterialForMenu | SearchMaterial;
  isLecturerMaterial?: boolean;
};

const MaterialIconProvider: FunctionComponent<MaterialIconProviderProps> = ({
  material,
  isLecturerMaterial = false,
}) => {
  let iconColor = defaultTheme.UI_COLORS.medium_gray;

  switch (material.status) {
    case PASS_STATUS.NOT_VISITED:
      iconColor = defaultTheme.UI_COLORS.medium_gray;
      break;

    case PASS_STATUS.VISITED:
    case PASS_STATUS.DONE:
      iconColor = defaultTheme.UI_COLORS.secondary;
      break;
  }

  if (isLecturerMaterial) {
    iconColor = defaultTheme.UI_COLORS.alert;
  }

  switch (material.type) {
    case MATERIAL_TYPES.PRESENTATION_PDF:
    case MATERIAL_TYPES.PRESENTATION_REVEAL:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8334 0.666656C16.2141 0.666656 17.3334 1.78594 17.3334 3.16666V9.83332C17.3334 11.214 16.2141 12.3333 14.8334 12.3333H10.3469L12.2795 16.0544C12.4829 16.4461 12.3543 16.9283 11.9829 17.1667C11.56 17.4381 10.9954 17.2875 10.7638 16.8416L9.00022 13.4459L7.23664 16.8416C7.00505 17.2875 6.44041 17.4381 6.01755 17.1667C5.64611 16.9283 5.51754 16.4461 5.72097 16.0544L7.65357 12.3333H3.16675C1.78604 12.3333 0.666748 11.214 0.666748 9.83332V3.16666C0.666748 1.78594 1.78604 0.666656 3.16675 0.666656H14.8334ZM14.8334 2.33332H3.16675C2.73938 2.33332 2.38716 2.65502 2.33902 3.06947L2.33341 3.16666V9.83332C2.33341 10.2607 2.65511 10.6129 3.06956 10.661L3.16675 10.6667H14.8334C15.2608 10.6667 15.613 10.345 15.6611 9.93051L15.6667 9.83332V3.16666C15.6667 2.73929 15.345 2.38707 14.9306 2.33893L14.8334 2.33332Z"
            fill={iconColor}
          />
        </svg>
      );

    case MATERIAL_TYPES.ATTACHMENT:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="18"
          viewBox="0 0 12.82 15.57"
          fill={iconColor}
        >
          <path d="M11.2,4.58v8.06A1.25,1.25,0,0,1,10,13.89H3a1.25,1.25,0,0,1-1.25-1.25V2.83A1.25,1.25,0,0,1,3,1.58H8.17v-1H3A2.25,2.25,0,0,0,.76,2.83v9.81A2.25,2.25,0,0,0,3,14.89H10a2.25,2.25,0,0,0,2.25-2.25V4.58Z" />
          <polyline points="12.16 3.32 9.42 3.32 9.42 0.57" />
          <path d="M6.75,5A1.33,1.33,0,0,0,5.43,6.35v3A.79.79,0,0,0,7,9.3V7.36a.26.26,0,1,0-.52,0V9.3A.27.27,0,0,1,6,9.3v-3a.79.79,0,0,1,1.58,0V9.56a1.32,1.32,0,0,1-2.64,0V6.35a.27.27,0,0,0-.53,0V9.56a1.89,1.89,0,0,0,.54,1.31,1.85,1.85,0,0,0,1.31.54A1.84,1.84,0,0,0,8.07,9.56V6.35A1.32,1.32,0,0,0,6.75,5Z" />
        </svg>
      );

    case MATERIAL_TYPES.ARTICLE:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="18"
          viewBox="0 0 14 18"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6392 4.00002L10.3482 0.666687H10.3334V4.00002H13.6392ZM8.66671 0.666687H2.83337C1.45266 0.666687 0.333374 1.78598 0.333374 3.16669V14.8334C0.333374 16.2141 1.45266 17.3334 2.83337 17.3334H11.1667C12.5474 17.3334 13.6667 16.2141 13.6667 14.8334V5.66669H8.66671V0.666687ZM8.65557 2.33335H2.83337C2.40601 2.33335 2.05378 2.65505 2.00565 3.0695L2.00004 3.16669V14.8334C2.00004 15.2607 2.32174 15.6129 2.73619 15.6611L2.83337 15.6667H11.1667C11.5941 15.6667 11.9463 15.345 11.9944 14.9305L12 14.8334V5.68027H8.65557V2.33335ZM4.08337 4.83335C3.85326 4.83335 3.66671 5.0199 3.66671 5.25002C3.66671 5.48014 3.85326 5.66669 4.08337 5.66669H6.58337C6.81349 5.66669 7.00004 5.48014 7.00004 5.25002C7.00004 5.0199 6.81349 4.83335 6.58337 4.83335H4.08337ZM3.66671 7.75002C3.66671 7.5199 3.85326 7.33335 4.08337 7.33335H9.91671C10.1468 7.33335 10.3334 7.5199 10.3334 7.75002C10.3334 7.98014 10.1468 8.16669 9.91671 8.16669H4.08337C3.85326 8.16669 3.66671 7.98014 3.66671 7.75002ZM4.08337 9.83335C3.85326 9.83335 3.66671 10.0199 3.66671 10.25C3.66671 10.4801 3.85326 10.6667 4.08337 10.6667H9.91671C10.1468 10.6667 10.3334 10.4801 10.3334 10.25C10.3334 10.0199 10.1468 9.83335 9.91671 9.83335H4.08337ZM3.66671 12.75C3.66671 12.5199 3.85326 12.3334 4.08337 12.3334H9.91671C10.1468 12.3334 10.3334 12.5199 10.3334 12.75C10.3334 12.9801 10.1468 13.1667 9.91671 13.1667H4.08337C3.85326 13.1667 3.66671 12.9801 3.66671 12.75Z"
            fill={iconColor}
          />
        </svg>
      );

    case MATERIAL_TYPES.EXERCISE:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="16"
          viewBox="0 0 16 18"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 0.666687C6.91333 0.666687 5.99716 1.36419 5.65299 2.33335H2.16667C1.24583 2.33335 0.5 3.07919 0.5 4.00002V15.6667C0.5 16.5875 1.24583 17.3334 2.16667 17.3334H13.8333C14.7542 17.3334 15.5 16.5875 15.5 15.6667V4.00002C15.5 3.07919 14.7542 2.33335 13.8333 2.33335H10.347C10.0028 1.36419 9.08667 0.666687 8 0.666687ZM8 2.33335C8.46 2.33335 8.83333 2.70669 8.83333 3.16669C8.83333 3.51169 8.62296 3.80835 8.32389 3.93492L8 4.00002L7.67611 3.93492C7.37704 3.80835 7.16667 3.51169 7.16667 3.16669C7.16667 2.70669 7.54 2.33335 8 2.33335ZM2.16667 4.00002H3.83333V4.83335C3.83333 5.29335 4.20667 5.66669 4.66667 5.66669H11.3333C11.7933 5.66669 12.1667 5.29335 12.1667 4.83335V4.00002H13.8333V15.6667H2.16667V4.00002ZM11.6576 9.53875C11.9831 9.21331 11.9831 8.68567 11.6576 8.36024C11.3322 8.0348 10.8046 8.0348 10.4791 8.36024L7.53279 11.3066L6.35421 10.128C6.02877 9.80255 5.50113 9.80255 5.1757 10.128C4.85026 10.4534 4.85026 10.9811 5.1757 11.3065L6.94346 13.0743C7.06553 13.1963 7.21605 13.2726 7.37368 13.3031C7.38582 13.3055 7.39799 13.3075 7.4102 13.3093C7.66224 13.3466 7.9281 13.2683 8.1221 13.0743L11.6576 9.53875Z"
            fill={iconColor}
          />
        </svg>
      );

    case MATERIAL_TYPES.QUIZ:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 13 13"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2432 0.895155C12.4872 1.13923 12.4872 1.53496 12.2432 1.77904L9.59414 4.42807L9.59153 4.43069C9.43015 4.59207 9.20248 4.64675 8.99618 4.59473C8.92945 4.57791 8.86497 4.54992 8.80568 4.51078C8.77102 4.48789 8.73814 4.4612 8.70763 4.43069L8.7064 4.42945L7.38182 3.10487C7.13774 2.86079 7.13774 2.46506 7.38182 2.22099C7.6259 1.97691 8.02162 1.97691 8.2657 2.22099L9.14958 3.10486L11.3593 0.895155C11.6034 0.651078 11.9991 0.651078 12.2432 0.895155ZM4.625 0.750019C4.90114 0.750019 5.125 0.973876 5.125 1.25002V5.25002C5.125 5.52616 4.90114 5.75002 4.625 5.75002H0.625C0.348858 5.75002 0.125 5.52616 0.125 5.25002V1.25002C0.125 0.973876 0.348858 0.750019 0.625 0.750019H4.625ZM4.12501 1.75003H1.12501V4.75003H4.12501V1.75003ZM11.5 7.62502C11.7761 7.62502 12 7.84888 12 8.12502V12.125C12 12.4012 11.7761 12.625 11.5 12.625H7.5C7.22386 12.625 7 12.4012 7 12.125V8.12502C7 7.84888 7.22386 7.62502 7.5 7.62502H11.5ZM11 8.62503H8.00001V11.625H11V8.62503ZM5.125 8.12502C5.125 7.84888 4.90114 7.62502 4.625 7.62502H0.625C0.348858 7.62502 0.125 7.84888 0.125 8.12502V12.125C0.125 12.4012 0.348858 12.625 0.625 12.625H4.625C4.90114 12.625 5.125 12.4012 5.125 12.125V8.12502ZM1.12501 8.62503H4.12501V11.625H1.12501V8.62503Z"
            fill={iconColor}
          />
        </svg>
      );

    case MATERIAL_TYPES.SNIPPET:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 12.75 15.83"
          width="14"
          height="18"
          fill={iconColor}
        >
          <path d="M11,4.84V12.9a1.25,1.25,0,0,1-1.25,1.25H2.84A1.25,1.25,0,0,1,1.59,12.9V3.09A1.25,1.25,0,0,1,2.84,1.84H8v-1H2.84A2.25,2.25,0,0,0,.59,3.09V12.9a2.25,2.25,0,0,0,2.25,2.25H9.78A2.25,2.25,0,0,0,12,12.9V4.84Z" />
          <polyline points="11.99 3.58 9.24 3.58 9.24 0.84" />
          <path d="M6.75,6.42a.4.4,0,0,0-.48.3l-.75,3.35a.4.4,0,0,0,.31.48h.09a.41.41,0,0,0,.4-.31L7.06,6.9a.4.4,0,0,0-.31-.48Z" />
          <path d="M4.7,6.79a.4.4,0,0,0-.57.06L3,8.23a.38.38,0,0,0,0,.51l1.14,1.38a.39.39,0,0,0,.31.15.43.43,0,0,0,.26-.09.41.41,0,0,0,0-.58L3.83,8.49l.92-1.12a.41.41,0,0,0,0-.58Z" />
          <path d="M8.49,6.85a.4.4,0,0,0-.57-.06.41.41,0,0,0-.06.58l.93,1.12L7.86,9.6a.41.41,0,0,0,.06.58.38.38,0,0,0,.25.09.41.41,0,0,0,.32-.15L9.63,8.74a.38.38,0,0,0,0-.51Z" />
        </svg>
      );

    default:
      return <span />;
  }
};

export default MaterialIconProvider;
